import React from "react";
import ReusableModal from "components/Modals/ReusableModal";

const ArchiveHelpTopic = ({ isOpen, onClose, onConfirm, topicTitle }) => {
  const bodyMessage = `Are you sure you want to archive this help topic? This action cannot be undone.`;

  return (
    <ReusableModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onConfirm}
      title="Confirm Archive"
      bodyMessage={<div dangerouslySetInnerHTML={{ __html: bodyMessage }} />}
      confirmLabel="Confirm"
      cancelLabel="Cancel"
    />
  );
};

export default ArchiveHelpTopic;
